import React, {useCallback, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {AgGridReact} from "ag-grid-react";
import {FaPlusSquare} from "react-icons/fa";
import TemplateDefault from "../../../components/template-default";
import Card from "../../../components/card";
import Button from "../../../components/button";
import InputForm from "../../../components/input-form";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import {buildAccentInsensitiveColDef, setAccentInsensitiveQuickFilter} from "../../../utils/ag-grid-quick-filter";

const defaultColumns = [
    {field: "name", headerName: "Nome", flex: 1},
];

const NamedResourceList = ({title, newLabel, basePath, queryKey, service, columns = defaultColumns}) => {
    const navigate = useNavigate();
    const gridRef = useRef();
    const [columnDefs] = useState(columns);
    const defaultColDef = useMemo(() => buildAccentInsensitiveColDef({resizable: false}), []);

    const {data: records, isFetching} = useQuery({
        queryFn: () => service.list().then(({data}) => data),
        queryKey: [queryKey],
    });

    const onFilterTextBoxChanged = useCallback(({target}) => {
        setAccentInsensitiveQuickFilter(gridRef, target.value);
    }, []);

    return (
        <TemplateDefault title={title} isLoading={isFetching}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <Button col="col-span-2" onClick={() => navigate(`${basePath}/form`)}>
                        <FaPlusSquare/> {newLabel}
                    </Button>
                    <InputForm id="search" col="col-span-10" label="Pesquisar" type="search"
                               onChange={onFilterTextBoxChanged}/>
                </div>

                <div className="ag-theme-quartz grid mt-4" style={{height: "calc(100vh - 159px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={records ?? []}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        pagination
                        paginationPageSize={500}
                        paginationPageSizeSelector={[10, 50, 100, 500]}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        suppressCellFocus={true}
                        gridOptions={{localeText: LocalizationAgGrid}}
                        onCellClicked={({data}) => navigate(`${basePath}/form/${data.id}`)}
                    />
                </div>
            </Card>
        </TemplateDefault>
    );
};

export default NamedResourceList;
